import { Component, inject } from '@angular/core';
import { UiButton } from './button.directive';
import { ConfirmService } from './confirm.service';
import { UiModal } from './modal';

/**
 * Host del diálogo de confirmación. Se monta una sola vez (en app.html) y
 * muestra el modal cuando `ConfirmService` tiene una petición pendiente.
 */
@Component({
  selector: 'ui-confirm',
  imports: [UiButton, UiModal],
  template: `
    @if (confirm.peticion(); as p) {
      <ui-modal [abierto]="true" [titulo]="p.titulo" (cerrar)="confirm.responder(false)">
        <p class="text-sm text-gray-600 dark:text-gray-300">{{ p.mensaje }}</p>
        <div class="mt-6 flex justify-end gap-2">
          <button uiButton type="button" (click)="confirm.responder(false)">
            {{ p.cancelar ?? 'Cancelar' }}
          </button>
          <button uiButton [variant]="p.variante ?? 'primary'" type="button" (click)="confirm.responder(true)">
            {{ p.confirmar ?? 'Confirmar' }}
          </button>
        </div>
      </ui-modal>
    }
  `,
})
export class UiConfirm {
  protected readonly confirm = inject(ConfirmService);
}
